<template>
  <FormSection title="Profilbild">
    <template #text>
      Ändere dein Profilbild, das für andere sichtbar ist.
    </template>
    <template #form>
		  <ImageForm v-model="resource" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <SubmitButton @click="onSubmit" :load="uploading">
      Speichern
    </SubmitButton>
  </FormButtons>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useUploadResource } from '@/client/actions';

const store = useStore();
const target = computed(() => '/api/account/image');
const action = useUploadResource(target);

const { resource, upload, uploading, errors, message } = action;

const onSuccess = () => store.dispatch('auth/reload');
const onSubmit = () => upload(onSuccess);
</script>
